import { Link } from 'react-router-dom';
import { ArrowUpward, IconHeadsetMic, IconWhatsapp } from '../Icons';
import styles from './Index.module.css';

export function SideMenu() {
    function scrollToTop(behavior) {
        window.scrollTo({ top: 0, behavior });
    }

    return <>
        <div className={`${styles.FloatIcon} ${styles.TopIcon}`} onClick={() => { scrollToTop("smooth") }}>
            <ArrowUpward size='36'></ArrowUpward>
        </div>

        <Link to="/opc_gerais/central_ajuda/" onClick={() => { scrollToTop("instant") }} className={`${styles.FloatIcon} ${styles.Zap}`}>
            <IconHeadsetMic color='var(--cor_tooMe)' size='36'></IconHeadsetMic>
            <b>Contato</b>
        </Link>
    </>
}